<template>
  <div class="main-content">
    <div class="page-header">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">Settings</li>
      </ol>
    </div>
    <form @submit.prevent="saveImage()">
    <tabs v-if="Object.keys(settings).length !== 0" class="tabs-default status-switch">
      <tab v-for="section in Object.keys(settings).sort()" :key="section" :id="section" :name="section | capitalize" class="tabs--container">
        <div v-for="setting in Object.keys(settings[section])" :key="setting" class="row">
          <div class="col">
            <div v-if="settings[section][setting].field_type === 'string'" class="form-group">
              <label>{{ setting | capitalize }}</label>
              <input
                v-model.trim="settings[section][setting].value"
                type="text"
                class="form-control"
              >
            </div>

            <div v-if="settings[section][setting].field_type === 'text'" class="form-group">
              <label>{{ setting | capitalize }}</label>
              <quill-editor ref="contentEditor" v-model="settings[section][setting].value" :class="form-control"/>

            </div>
            <div v-if="settings[section][setting].field_type === 'boolean'" class="form-check">
              <input v-model.trim="settings[section][setting].value" type="checkbox" class="form-check-input">
              <label class="form-check-label">{{ setting | capitalize }}</label>
            </div>
            <div v-if="settings[section][setting].field_type === 'image'" class="form-group">
            <label>{{ setting | capitalize }} </label>
            <br >

            <img-inputer v-model="file[setting.split(' ').join('_')]"  :img-src="photoImg(settings[section][setting].value)"  exceed-size-text="Size of the file should be less than " theme="light" size="large" accept="image/*" />


            <br >
            <button type="button" class="btn btn-danger" @click="settings[section][setting].value = null">Clear</button>
          </div>
          </div>
        </div>
      </tab>
    </tabs>
    <br>
    <div class="card">
      <div class="card-body">
        <button type="submit" class="btn btn-success" @click="save">Save</button>
      </div>
    </div>
    </form>
  </div>
</template>

<script>
/* global axios, toastr */
import { Tabs, Tab } from 'vue-tabs-component'

export default {
  name: 'Settings',
  components: {
    tabs: Tabs,
    tab: Tab
  },
  data: () => {
    return {
      settings: {},
      file: []
    }
  },
   
  beforeRouteEnter (to, from, next) {
    axios
      .get('/api/admin/settings')
      .then(repsonse => {
        next(vm => (vm.settings = repsonse.data.settings))
      })
      .catch(error => {
        console.log(error)
        next()
      })
  },
  methods: {
     photoImg(value) {

      if (typeof value === 'string') {
        return value
      }
      return null
    },

    save () {
      axios.post('/api/admin/settings', {
        settings: this.settings
      })
        .then(response => {
          if (response && response.data && response.data.result === 'ok') {
            toastr['success']('Changes have been saved successfully')
          } else {
            let message = (response && response.data && response.data.message) || 'Something goes wrong'
            toastr['error'](message)
          }
        })
        .catch(error => {
          let message = (error && error.message) || 'Something goes wrong'
          toastr['error'](message)
        })
    },
    saveImage(){


        let formData = new FormData()
          for (var key in this.file) {

          formData.append(key,this.file[key])
          }

        axios.post('/api/admin/settings/image', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then(response => {
            if (response && response.data && response.data.result === 'ok') {
              this.record = response.data.record
              toastr['success']('Changes were saved successfully')
            } else {
              let message = (response && response.data && response.data.message) || 'Something goes wrong'
              toastr['error'](message)
            }
          })
          .catch(error => {
            let message = (error && error.message) || 'Something goes wrong'
            toastr['error'](message)
          })
      }
    }
  }
</script>

<style>
.tabs--container {
  padding: 0 16px;
}
</style>
